import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchBotActivities } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import LoadingSpinner from "../../../Components/spinner";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function SuspiciousActivityAlerts() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [selectedUserType, setSelectedUserType] = useState("");

  const getBotActivities = async () => {
    const res = await fetchBotActivities();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (selectedUserType?.length) {
        const temp = res?.data?.data?.filter(
          (f) => f.userType === selectedUserType
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    }
    setFetching(false);
  };

  const handleChangeUserType = (str) => {
    setSelectedUserType(str);
    if (str?.length) {
      const temp = tableData?.filter((f) => f.userType === str);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedUserType("");
    setFilteredData(tableData);
  };

  const chartData = {
    labels: filteredData.map(
      (item) => `${item.userType} (${item.behaviour_type})`
    ),
    datasets: [
      {
        label: "Suspicious Users",
        data: filteredData.map((item) => item.count),
        backgroundColor: "rgba(255, 99, 132, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getBotActivities();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item?.userType, item?.behaviour_type, item.count];
    });
    const config = {
      data: rows,
      columns: [
        { title: "User Type" },
        { title: "Suspicious Activity" },
        { title: "Count" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedUserType}
                onChange={(e) => handleChangeUserType(e.target.value)}
              >
                <option value="">All user types</option>
                <option value="Guest">Guest</option>
                <option value="Registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              {fetching ? (
                <LoadingSpinner size={"small"} />
              ) : (
                <Button className="btn btn-success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Suspicious Activity Alerts</h5>
          <p className="card-text">
            Analyzing this data can help you Detect unusual patterns (e.g., bots
            generating fake ad views).
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Suspicious Activity Count</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default SuspiciousActivityAlerts;
